var handleScroll = null;
// 注册全局指令
export default {
  // 指令绑定到元素时执行
  bind(el, binding) {
    if (binding.value !== false) {
      var videoBox = el;
      var lastVideo = null; // 上一个播放视频元素
      var timeout = null;
      handleScroll = debounce(function() {
        var videos = el.querySelectorAll('video');
        // const UA = navigator.userAgent;
        // const isIos = !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        for (let i = 0; i < videos.length; i++) {
          // if (isIos) {
            videos[i].setAttribute('playsinline', 'true');
            videos[i].setAttribute('webkit-playsinline', 'true');
          // }
        }
        // 对视频元素进行遍历，并判断哪些视频已经完整出现在可视区
        for (let i = 0; i < videos.length; i++) {
          let video = videos[i];
          // 如果视频元素完整出现在可视区域内，且未被静音，则将其静音并播放
          if (isElementFullyInViewport(video)) {
            // 记录当前播放视频元素的下标
            if (lastVideo) {
              // 遍历 video 的 source 子元素
              const isSame = [...video.querySelectorAll('source')].some(
                source => {
                  // 如果当前 source 是当前播放源，则输出其 src 属性值
                  // lastVideo.querySelectorAll('source')
                 return [...lastVideo.querySelectorAll('source')].some(lastVideoSource=>{
                    return source.src === lastVideoSource.src
                  })
                  // return source.src === lastVideo.src;
                }
              );
              console.log(isSame);

              // 判断是否需要暂停上一个播放视频元素
              if (!isSame) {
                lastVideo.pause();
                lastVideo = null;
              } else {
                return;
              }
            }
            // 更新上一个播放视频元素
            lastVideo = video;
            lastVideo.muted = true;
            if (timeout) {
              clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
              lastVideo.play();
            }, 500);
            // 开始播放视频
            return;
          }
        }
      }, 200);
      // 在 div 中监听 scroll 事件
      videoBox.addEventListener('scroll',handleScroll);

      // 判断元素是否完整出现在可视区域内的函数
      function isElementFullyInViewport(el) {
        var rect = el.getBoundingClientRect();
        var topDistance = rect.top - videoBox.getBoundingClientRect().top;
        var bottomDistance = rect.bottom - videoBox.getBoundingClientRect().top;
        return topDistance >= 0 && bottomDistance <= videoBox.clientHeight;
      }

      // 防抖函数
      function debounce(fn, delay) {
        var timer = null;
        return function() {
          var args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function() {
            fn.apply(this, args);
          }, delay);
        };
      }
    }
  },
  unbind(el) {
    el.removeEventListener('scroll',handleScroll);
  }
};
